import { css } from 'emotion'

const name = (point, selected) => {
  if (selected) {
  }
  if (point.toDelete) {
    return css`
      transition: color 0.5s;
      text-decoration: line-through;
      color: #807978;
      cursor: pointer;
    `
  }
  if (point.status === 'inactive') {
    return css`
      transition: color 0.5s;
      color: #aca4a3;
      cursor: pointer;
    `
  }
  return css`
    transition: color 0.5s;
    cursor: pointer;
  `
}

export default { name }
